import { Winner } from "@/features/winners/models/winner";
import { formatShortNameWithState } from "@/lib/utils";

function PreviousWinner({ winner }: { winner: Winner }) {
	const baseURL = import.meta.env.VITE_SERVER_API_URL;
	const prizeImage = `${baseURL}/common/image/${winner.promotion?.prize?.images[0].url}`;
	const winnerPhoto = winner.photo
		? `${baseURL}/common/image/${winner.photo}`
		: prizeImage;

	return (
		<div className="flex flex-col gap-8 text-left">
			<div className="h-32 w-38 md:h-82 md:w-95">
				<img
					src={winnerPhoto}
					className="h-full w-full rounded-[32px] object-cover"
				/>
			</div>

			<div className="flex flex-col gap-2">
				<div className="flex flex-col justify-between md:flex-row">
					<p className="web-heading-h4 text-white">
						{formatShortNameWithState(
							winner.winner.fullName,
							winner.winner.stateName
						)}
					</p>
					<p className="web-body-b1 text-white-80">
						{winner.promotion.endDate.toLocaleString()}
					</p>
				</div>
				<p className="web-body-b1 text-white-80">
					{winner.promotion.prize.title}
				</p>
			</div>
		</div>
	);
}

export default PreviousWinner;
